<template>
  <v-dialog max-width="600px" v-model="show">
    <v-card>
      <v-card-title>申込書Upload</v-card-title>
      <v-card-text>
        <v-text-field
          :rules="[
                v => !!v || ` Email is required`, 
                v=> /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,10})+$/.test(v) || `E-mail must be valid`
                ]"
          label="Email"
          v-model="email"
        />
      </v-card-text>
      <v-card-text v-if="total>0">
        <div>{{loaded}}/{{total}}</div>
        <v-progress-linear :value="loaded * 100 / total" class="mt-0"></v-progress-linear>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="!canUpload" @click="upload" flat>Upload</v-btn>
        <v-btn @click="show=false" flat>Cancel</v-btn>
      </v-card-actions>
    </v-card>
    <input @change="fileChanged" ref="file" style="display: none" type="file">
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      email: null,
      loaded: 0,
      total: 0,
      loading: false
    }
  },
  methods: {
    upload() {
      this.$refs.file.click()
    },
    fileChanged(e) {
      if (e.target.files.length === 0) return
      let file = e.target.files[0]
      let formData = new FormData()
      formData.append('file', file)
      formData.append('category', 'enroll')
      return this.$http
        .post(`/files/users/${this.email}/files`, formData, {
          headers: { 'Content-Type': 'multipart/form-data', sortable: false },
          onUploadProgress: event => {
            if (event.lengthComputable) {
              this.loaded = event.loaded
              this.total = event.total
            }
          },
          quiet: true
        })
        .then(() => {
          this.show = false
          this.loaded = 0
          this.total = 0
          this.userId = null
          this.$message('', 'UPLOAD完了')
        })
        .catch(() => {
          this.$message('', '上传失败')
        })
    }
  },
  computed: {
    canUpload() {
      return this.email
    }
  }
}
</script>